import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";

export default GrComponentFactory.createClass({
  displayName: "BlogNewsfeedItemBody",

  propTypes: {
    resource: GrPropTypes.blogNewsfeedResource(),
  },

  renderImage() {
    if (this.props.resource.imageUrl) {
      return (
        <a href={this.props.resource.resourceUrl}>
          <img className="editorialCard__image"
            src={this.props.resource.imageUrl}
            alt={this.props.resource.title} />
        </a>
      );
    } else {
      return null;
    }
  },

  body() {
    return { __html: this.props.resource.body.html };
  },

  render() {
    return (
      <div className="editorialCard">
        {this.renderImage()}
        <div className="editorialCard__title">
          <a href={this.props.resource.resourceUrl}
            className="gr-hyperlink gr-hyperlink--bold">
            {this.props.resource.title}
          </a>
        </div>
        <div className="editorialCard__body"
          dangerouslySetInnerHTML={this.body()} />
      </div>
    );
  },
});
